import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh, setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login");
      return;
    }
    const session_id = m[1];
    const referral_code = sessionStorage.getItem("sb_referral") || null;
    const agreed_to_terms = sessionStorage.getItem("sb_agreed_terms") === "true";

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id, referral_code, agreed_to_terms });
        setUser(data.user);
        sessionStorage.removeItem("sb_referral");
        sessionStorage.removeItem("sb_agreed_terms");
        sessionStorage.removeItem("sb_agreed_terms_at");
        // Clear the hash and route based on state
        window.history.replaceState(null, "", "/");
        if (!data.user.is_approved && !["admin", "superadmin"].includes(data.user.role)) {
          navigate("/pending", { replace: true });
        } else if (["admin", "superadmin"].includes(data.user.role)) {
          navigate("/admin", { replace: true });
        } else {
          navigate("/cities", { replace: true });
        }
      } catch (e) {
        await refresh();
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, refresh, setUser]);

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center gap-3">
      <Loader2 className="h-6 w-6 animate-spin text-primary" />
      <p className="text-sm text-muted-foreground">Signing you in…</p>
    </div>
  );
}
